<script setup lang="ts">
import { defineProps } from "vue";

defineProps<{
    size: number;
}>();
</script>

<template>
    <div class="Logo" :style="{ height: size + 'px' }">
        <img
            class="h-full"
            src="images/crs-i-logo-bw 1.png"
            alt="Poslednik Logo"
        />
    </div>
</template>
